import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { connect } from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import SelectGeneric from "../../../components/select/selectGeneric";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { FORM, INTERNATIONAL, REQUIRED } from "../../../components/i18n/i18n";
import {
    FL_ICON, FL_INVERTED_ICON,
    FL_POINT_A,
    FL_POINT_B,
    FL_WEIGHT,
} from "../../../components/i18n/formLabels";

import { save, update } from "../../../redux/actions/xeeker/vectorActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {pointProvider} from "../../../providers/pointProvider";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

const VectorForm = props => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { editMode, disableInputs, saveSuccess, domainObject } = props.formProps;

    const [pointAId, setPointAId] = useState(domainObject?.pointA?.id || null);
    const [pointBId, setPointBId] = useState(domainObject?.pointB?.id || null);
    const [resetValue, setResetvalue] = useState(false)
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        weight: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            weight: domainObject?.weight,
            icon: domainObject?.icon,
            invertedIcon: domainObject?.invertedIcon,
        }
    });

    const onSubmit = (data, _) => {
        if (pointAId === null)
            return;

        const dataRequest = {
            fbDataBase:  { id : fbDataBaseId },
            item: {
                ...data,

                uid: domainObject?.uid,
                langs: domainObject?.langs,
                udn: { id: props?.mainProps?.udn?.id },
                pointA : { id : pointAId },
                pointB : { id : pointBId },
            }
        }

        if (!editMode)
            return props.save(dataRequest);
        else {
            let id = domainObject.id;
            dataRequest.item.id = domainObject?.id

            return props.update(id, dataRequest)
        }
    };

    const resetForm = () => {
        props.setForm(false, false, false);
        props.resetCombos();
        setPointAId(null);
        setPointBId(null);
        setResetvalue(!resetValue);
        reset();
    }

    const beginEdit = () => {
        setResetvalue(!resetValue);
        props.setForm(true, false, false);
    }

    const returnToList = () => {
        props.setViewMode("LIST");
        props.setItem(null);
        props.setForm();
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{ FL_POINT_A }</Label>
                                <SelectGeneric
                                    initialValue={ pointAId }
                                    setExternalValue={ value => setPointAId( value ) }
                                    isDisabled={ false }
                                    provider = { pointProvider }
                                    resetValue={ resetValue }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{ FL_POINT_B }</Label>
                                <SelectGeneric
                                    initialValue={ pointBId }
                                    setExternalValue={ value => setPointBId( value ) }
                                    isDisabled={ false }
                                    provider = { pointProvider }
                                    resetValue={ resetValue }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{ FL_WEIGHT }</Label>
                                <Input
                                    type="number"
                                    name="weight"
                                    min="0"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{ FL_ICON }</Label>
                                <Input
                                    type="text"
                                    name="icon"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{ FL_INVERTED_ICON }</Label>
                                <Input
                                    type="text"
                                    name="invertedIcon"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                    </CardBody>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={ resetForm }/>
                                    <ButtonEdit onClick={ beginEdit }/>
                                    <ButtonCancel onClick={ returnToList }/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={ returnToList }/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(VectorForm)